import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import LightPanel from '../components/LightPanel';
import AuthActionsBar from '../components/AuthActionsBar';
import { PublicFooter } from '../components/PublicFooter';
import { BusinessHeader } from '../components/BusinessHeader';

export type HomeProps = RouteComponentProps<any>;

export default class Home extends React.Component<HomeProps, any> {
  render() {
    return (
      <div className="w-100 sans-serif">
        <BusinessHeader />
        <AuthActionsBar {...this.props} />
        <article className="bg-white black mw9 ml-auto mr-auto">
          <section id="features" className="pv5 pa3 pa5-ns">
            <div className="features list cf ma0 pa0">
              <LightPanel
                image_url="/images/branded.jpg"
                title="Start a conversation"
                subtitle={
                  'By creating a Brand page on Filtru, you are closer to the coffee community'
                }
              />
              <LightPanel
                image_url="/images/reporst.jpg"
                title="Over 20,000 users worldwide"
                subtitle="We are currently seeking partnerships and content creators
                to improve our content offering on the Filtru app - Get in touch."
              />
              <LightPanel
                image_url="/images/guided.jpg"
                title="Guide to your coffee"
                subtitle={
                  'Share your brew methods and let others discover different ways of making coffee'
                }
              />
              <LightPanel
                image_url="/images/reports.jpg"
                title="Learn about your customers"
                subtitle={
                  'Get reported on how your coffee is brewed and what people think of it'
                }
              />
            </div>
          </section>
        </article>
        <PublicFooter />
      </div>
    );
  }
}
